window.PXUTheme.jsCollection = {
  init: function($section) {
    // Add settings from schema
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // IE11 fix
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    if (!isIE11) {
      window.Shopify.loadFeatures([
        { name: 'shopify-xr', version: '1.0' },
        { name: 'model-viewer-ui', version: '1.0' }
      ]);
    }

    // Initialize default sort value
    if (this.enable_sorting) {
      $('[data-collection-sort]').each(function() {
        $(this).val($(this).data('default-sort'));
      });
    }

    // Listen to dropdowns
    if (this.enable_filter || this.enable_sorting) {
      $(document).on('change', '[data-collection-filter], [data-collection-sort]', function() {
        window.PXUTheme.jsCollection.filterURL(this);
      });
    }

    // Initialize active checkboxes
    $('[data-option-filter] input:checked').each(function() {
      window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
    });

    // Breadcrumbs
    if (this.enable_breadcrumb && this.pagination_type === 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    // Sidebar filtering
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();
      $(this).find('input').prop('checked', true);
      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    // Clear individual filters
    $('body').on('click', '[data-clear-filter]', function() {
      const $el = $(this).siblings('[data-option-filter]');
      $('#tag_filter').find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));
    });
  },

  filterURL: function(triggeredElement) {
    const $trigger = $(triggeredElement);
    const selectedOptions = [];
    let query = '';
    let currentTags = '';
    const siteUrl = `https://${$.url('hostname')}`;

    // Determine path (account for multilingual)
    const urlParts = [];
    for (let i = 1; i <= 3; i++) {
      const part = $.url(`${i}`);
      if (part) urlParts.push(part);
    }
    let path = '/' + urlParts.join('/').replace(/\/$/, '') + '/';

    // Sort dropdown logic
    if ($trigger.is('[data-collection-sort]')) {
      query = $trigger.val();
    } else if ($('[data-collection-sort]').length) {
      query = $('[data-collection-sort]').first().val();
    } else {
      query = $.url('?sort_by');
    }

    // Tag dropdown logic
    if ($trigger.is('[data-collection-filter]')) {
      const $tagSelect = $trigger;
      if ($tagSelect.data('default-collection') !== $tagSelect.val()) {
        const urlTag = $tagSelect.val().split('/').pop();
        if (urlTag && urlTag !== 'all') {
          selectedOptions.unshift(urlTag);
        }
      }
    } else if ($('[data-collection-filter]').length) {
      const $tagSelect = $('[data-collection-filter]').first();
      if ($tagSelect.data('default-collection') !== $tagSelect.val()) {
        const urlTag = $tagSelect.val().split('/').pop();
        if (urlTag && urlTag !== 'all') {
          selectedOptions.unshift(urlTag);
        }
      }
    }

    // Collect checked checkboxes
    $('[data-option-filter] input:checked').each(function() {
      selectedOptions.push($(this).val());
    });

    // Build tag string
    currentTags = selectedOptions.join('+');

    window.PXUTheme.queryParameters.sort_by = query;
    const queryString = '?' + $.param(window.PXUTheme.queryParameters);

    this.processUrl(path, currentTags, queryString);
  },

  processUrl: function(path, tags, query) {
    const cleanedQuery = query.replace(/\page=(\w+)&/, '');
    const urlString = path + tags + cleanedQuery;
    this.updateView(urlString);
  },

  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function(data) {},
      error: function(x, t, m) {
        console.error(x, t, m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: 'html'
    }).then(function(data) {
      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Update breadcrumb
      const newBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(newBreadcrumb);

      // Remove loading
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Update products
      const newProducts = $(data).find('.collection-matrix__wrapper');
      const newPagination = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      $collectionMain.empty();

      if (newProducts.length) {
        $collectionMain.append(newProducts);
      } else {
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(newPagination);

      if (window.history && window.history.pushState) {
        window.history.pushState('', '', filterURL);
      }

      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }
    });
  },

  multiTagFilter: {
    init: function($el) {
      this.showSelectedFilter($el);
      window.PXUTheme.jsCollection.filterURL($el);
      if ($.url(2) === 'types' || $.url(2) === 'vendors') {
        $('.block__tag-filter').remove();
      }
    },

    showSelectedFilter: function($el) {
      const $sidebarBlock = $el.closest('.sidebar-toggle-active');
      const $filterItem = $el.closest('.tag-filter__item');

      $filterItem.addClass('is-active').siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      if ($sidebarBlock.length) {
        const $toggleBtn = $sidebarBlock.find('[data-sidebar-block__toggle="closed"]');
        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    },

    clearSelectedFilter: function($el) {
      const $filterItem = $el.closest('.tag-filter__item');
      $filterItem.removeClass('is-active').find('input').prop('checked', false);
      $filterItem.siblings().removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]').addClass('is-hidden');
      window.PXUTheme.jsCollection.filterURL($el);
    }
  },

  unload: function() {
    $(document).off('change', '[data-collection-filter], [data-collection-sort]');
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    if (window.PXUTheme.breadcrumbs && window.PXUTheme.breadcrumbs.unload) {
      window.PXUTheme.breadcrumbs.unload();
    }
  }
};
